<template>
  <div id="candle-show">
    <disabled-overlay />
    <profile-module />
    <b-col>
      <h1 class="title">{{ $t('pages.candle.title') }}</h1>
    </b-col>

    <div style="margin-bottom: 40px; height: 50px; border: solid black 1px;">
      <div style="display: inline-block; margin-left: 3%; font-weight: bold; margin-top: 12px" @click="tab = 1"> Identification </div>
      <div style="display: inline-block; margin-left: 5%; font-weight: bold;" @click="tab = 2"> Caractéristiques  </div>
      <div style="display: inline-block; margin-left: 3%; font-weight: bold;" @click="tab = 3"> Historique  </div>
      <div style="display: inline-block; margin-left: 3%; font-weight: bold;" @click="tab = 4"> Propriétaires   </div>
      <div style="display: inline-block; margin-left: 3%; font-weight: bold;" @click="tab = 5"> Entretien </div>
      <div style="display: inline-block; margin-left: 3%; font-weight: bold;" @click="tab = 6"> Memo Entretien </div>
      <div style="display: inline-block; margin-left: 3%; font-weight: bold;" @click="tab = 7"> Tableau de correspondance </div>
    </div>

      <template v-if="tab === 1">

        <div>Marque : Jaguar</div>
        <div>Modele : MK120</div>
        <div>Finition : Cuir</div>
        <div>Couleur ext : Rouge</div>
        <div>Date de 1ere mise en circulation : 12/04/1948</div>
        <div>Kilometrage : 156.050km</div>

        <div style="width: 100%; height: 15px; "></div>

        <div>Immatriculation :XKSJIE53 </div>
        <div>N° de chassis/série : OKFE6565</div>
        <div>  N° de moteur : ED542PL</div>
        <div>  N° de boite : ED542PL</div>
        <div>  N° de pont : ED542PL</div>
        <div>  Observations : RAS</div>

        <div style="width: 100%; height: 15px; "></div>

        <div style="font-weight: bold; margin-bottom: 15px; margin-top: 15px">  Couleurs Actuelles</div>
        <div>  Carrosserie : Rouge</div>
        <div>  Réf peinture : #ff0000</div>
        <div>  Intérieur : Marron</div>
        <div>  Matière : Cuire</div>

        <div style="width: 100%; height: 15px; "></div>

        <div style="font-weight: bold; margin-bottom: 15px; margin-top: 15px">Couleurs d’origine</div>
        <div>  Carrosserie : Rouge</div>
        <div>  Réf peinture : #ff9090</div>
        <div>Intérieur : Noir</div>
        <div>Matière : Cuire </div>
    </template>

    <template v-else-if="tab === 2">

      <div style="font-weight: bold; margin-bottom: 15px; margin-top: 15px">Général</div>
      <div>Type de carrosserie : Sportif</div>
      <div>Nombre de places assises : 2</div>
      <div>Particularité du véhicule : </div>
      <div>Options d’usine : </div>

      <div style="font-weight: bold; margin-bottom: 15px; margin-top: 15px">Moteur</div>
      <div>Nombre de cylindres : </div>
      <div>Cylindrée :1.2L</div>
      <div>Type : rotatif</div>
      <div>Energie : Essence</div>
      <div>Ordre d’allumage : </div>
      <div>Observations : RAS</div>
      <div>Préparations moteurs / Modifications mécaniques : RAS</div>

  </template>

  <template v-else-if="tab === 3">
    <div>Date d’achat : 13/11/1948</div>
    <div>Lieu d’achat : Londres</div>
    <div>Nom du vendeur : Jaguar Londres</div>
    <div>Immatriculation lors de l’achat : FEZFZ546</div>
    <div>Etat du véhicule lors de l’achat : Neuf</div>
    <div>Notes : RAS</div>
  </template>

  <template v-else-if="tab === 4">
    <div>Nom : Jean François</div>
    <div>Prénom : Luternauer</div>
    <div>Téléphone : 0642524252</div>
    <div>E-mail : jf.lut@carappli.com</div>
    <div>Autre :</div>
    <div>Adresse : 63 chemin des roses, Lille</div>
    <div>Période de détention du véhicule : du 14/06/2018 </div>
    <div>Immatriculation : EDDE6318</div>
    <div>Notes : </div>
  </template>

  <template v-else-if="tab === 5">
    <div>Date de l’intervention : 14/06/2018</div>
    <div>Kilométrage : 155.035km</div>
    <div style="font-weight: bold; margin-bottom: 15px; margin-top: 15px">Principales opérations effectuées :</div>
    <div>Vidange  x, Filtre à essence x, Graissage x</div>
    <div>Vidange boite x, filtre a air x, freins avants x</div>
    <div>Vidange pont x, bougies x, freins arrières x</div>
    <div>Filtre à huile x, Contrôle niveaux X, Pression pneus</div>
    <div>Détails des opérations :</div>
    <div>Observations / Travaux à prévoir : Changer les freins avant</div>
    <div>Contrôle Technique fait le : 04/06/2018</div>
    <div>Prochain contrôle avant le : 04/06/2023</div>
    <div>Nom du garage / Mécano : Luter & Fils</div>
  </template>

  <template v-else-if="tab === 6">
    <div style="font-weight: bold; margin-bottom: 15px; margin-top: 15px">Equipement électrique</div>
    <div>Réf bougies : REXB101B01</div>
    <div>Réf batterie : RTR356B01</div>
    <div>Négatif à la masse X, Positif à la masse X</div>
    <div>Réf fusibles : REX651GH1B01</div>

    <div style="font-weight: bold; margin-bottom: 15px; margin-top: 15px">Filtres</div>
    <div>Réf filtre à air : REXB101B01</div>
    <div>Réf filtre à huile : REXB101B01</div>
    <div>Réf filtre à carburant : REXB101B01</div>

    <div style="font-weight: bold; margin-bottom: 15px; margin-top: 15px">Pneus</div>
    <div>Dimensions pneus avant : 185R16</div>
    <div>Dimensions pneus arrière : 185R16</div>
    <div>Marques et modèles  couramment utilisés : Michelin Pilote</div>

    <div style="font-weight: bold; margin-bottom: 15px; margin-top: 15px">Fluides</div>
    <div>Réf huile moteur : ……………….contenance :</div>
    <div>Réf huile boite :…………………….contenance :</div>
    <div>  Réf huile overdrive si différente :</div>
    <div>Réf huile de pont :</div>
    <div>Réf liquide frein :</div>
    <div>  Réf liquide embrayage :</div>

    <div style="font-weight: bold; margin-bottom: 15px; margin-top: 15px">Carburant</div>
    <div>Type : Essence</div>
    <div>Additif : </div>

    <div style="font-weight: bold; margin-bottom: 15px; margin-top: 15px">Divers</div>
    <div>Réf plaquettes de frein :</div>
    <div>Réf courroie d’accessoire :</div>
    <div>Réf vis platinées :</div>

    <div style="font-weight: bold; margin-bottom: 15px; margin-top: 15px">Mémo Contact</div>
    <div>Métier : Mécanicien</div>
    <div>Nom : Luternauer Alexandre</div>
    <div>Tel : 0632125465</div>
    <div>Mail : alex.lut@carappli.com</div>
    <div> Adresse : 35 rue pierre Deschamps</div>

  </template>

  <template v-else-if="tab === 7">

    <div style="font-weight: bold; margin-bottom: 15px; margin-top: 15px">Vitesse / Speed / Velocity:</div>
    <div>1 mph = 1.609 km /h</div>

    <div style="font-weight: bold; margin-bottom: 15px; margin-top: 15px">Température / Temperature : </div>
    <div>Degré Celcius = °F – 32 x0.56</div>
    <div>Degré Fahrenheit = (°C x 1.8 ) +32</div>

    <div style="font-weight: bold; margin-bottom: 15px; margin-top: 15px">Pression (Pressure): </div>
    <div>1 psi  ou lbi/in² = 0.0703 kg/cm² = 0.069 bar = 6.895 kPa = 0.068 atm </div>
    <div>Consommation  / Consumption</div>
    <div>L/ 100 km = 282 (Imperial mpg GB)</div>
    <div>L/100 km = 235 US mpg</div>

    <div style="font-weight: bold; margin-bottom: 15px; margin-top: 15px">Longueur / length</div>
    <div>1 mile = 1.609 km</div>
    <div>1 inch (inch) = 25.4 mm</div>
    <div>1 ft (foot) = 12 in = 0.305 m</div>
    <div>1 yd (yard) = 3 ft = 0.914 m</div>

    <div style="font-weight: bold; margin-bottom: 15px; margin-top: 15px">Masse / weight</div>
    <div>1 oz (ounce) = 28.35 g</div>
    <div>1 lb (pound) = 16 oz= 0.454 kg</div>
    <div>1 cwt (quaterweight) = 112 lb = 50.802 kg</div>
    <div>1 ton ( long ton GB) = 1 016 kg</div>
    <div>1 ton (short ton US) = 907.20 kg</div>

    <div style="font-weight: bold; margin-bottom: 15px; margin-top: 15px">Volume / Capacity</div>
    <div>1 cu in ( cubic inch) = 16.39 cm3</div>
    <div>1 pt (pint GB) = 0.568 L</div>
    <div>1 qt (quart GB) =1.136 L</div>
    <div>1 liq qt (US quart) = 0.946 L</div>
    <div>1 gal  GB (imp.gallon) = 4.546 L</div>
    <div>1 gal US ( US gallon) = 3.785 L</div>

    <div style="font-weight: bold; margin-bottom: 15px; margin-top: 15px">Puissance / Power</div>
    <div>1 ch (DIN) = 1.36 ch (SAE) = 0.736 kW (kilowatt)</div>
    <div>1 hp (horse power) = 1.014 ch (cheval vapeur) =0.746 kW</div>

    <div style="font-weight: bold; margin-bottom: 15px; margin-top: 15px">Couple / Torque</div>
    <div>1 lb/ft (pound force per feet) = 0.138 kg/m = 1.356 Nm</div>

  </template>

    <e-index
      :uri="$helper.getUri('candle')"
      :modal-uri-create="`api/public/memorial/${id}/candle`"
      :modal-uri="`api/memorial/${id}/candle`"
      :order-call-back="orderCallBack"
      :can-manage="$root.canManage()"
      :can-create="!$root.isDemo() || $root.canManage()"
      :mosaic-cols="4"
      name="candle"
      mode="mosaic"
      style="display: none"
    >

      <div slot="mosaic-content" slot-scope="ctx">
        <div
          v-if="ctx.item.image !== null"
          :style="`background-image:url(${$helper.imageUrl(ctx.item.image.file_url, true)})`"
          class="thumbnail clickable"
          @click="openModal(modalName('image'), ctx.item)"
        >
          <i class="ti ti-fw ti-2x ti-search" />
          <div class="text">{{ $helper.demoFallbackTranslation(ctx.item, 'text') }}</div>
        </div>
        <contact-entity :contact="ctx.item.contact" />
      </div>
    </e-index>
    <e-modal :event-id="modalName('image')" class="image-modal has-navigate">
      <navigate :item="candle" name="candle" />
      <div class="candle-content">
        <div class="text">{{ $helper.demoFallbackTranslation(candle, 'text') }}</div>
        <img v-if="candle.image" :src="$helper.imageUrl(candle.image.file_url)" class="img-fluid">
      </div>
    </e-modal>
  </div>
</template>

<script>
  import EModal from '@/components/EModal';
  import EIndex from '@/components/EIndex';
  import ProfileModule from '@/components/ProfileModule';
  import DisabledOverlay from '@/components/DisabledOverlay';
  import Navigate from '@/components/Navigate';
  import ContactEntity from '@/components/ContactEntity';
  import MemorialGuard from '@/mixins/MemorialGuard';


  export default {
    name: 'CandleIndex',
    components: {
      EIndex,
      EModal,
      ProfileModule,
      DisabledOverlay,
      Navigate,
      ContactEntity,
    },
    mixins: [
      MemorialGuard,
    ],
    props: {
      id: {
        type: [Number, String],
        default: null,
      },
    },
    data() {
      return {
        // eslint-disable-next-line no-underscore-dangle
        uid: this._uid,
        candle: {},
        candles: {},
        tab: 1,
      };
    },
    mounted() {
      this.$bus.$once(`t-event.t-modal.image-${this.uid}.closed`, () => {
        this.candle = {};
      });

      this.$bus.$on('t-event.ajax-index.load-data-success', (candles) => {
        this.candles = candles;
      });

      this.$bus.$on('t-event.navigate.success', (candle) => {
        this.candle = candle;
        this.addNextPrev(this.candle);
      });
    },
    methods: {
      addNextPrev(data) {
        const currentCandleKey = _.findIndex(this.candles, candle => candle.id === data.id);

        if (this.candles[currentCandleKey + 1]) {
          data.next = this._.omit(this.candles[currentCandleKey + 1], 'next', 'prev');
        }

        if (this.candles[currentCandleKey - 1]) {
          data.prev = this._.omit(this.candles[currentCandleKey - 1], 'next', 'prev');
        }

        return data;
      },
      modalName(action) {
        return `${action}-${this.uid}`;
      },
      openModal(id, data = null) {
        if (id === this.modalName('image')) {
          this.candle = this.addNextPrev(data);
        }
        this.$bus.$emit(`t-event.t-modal.${id}.open`, data);
      },
      orderCallBack(collection) {
        return _.orderBy(collection, ['created_at'], ['desc']);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
  @import '~@/scss/media';

  .thumbnail {
    display: flex;
    align-items: center;

    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba($black, .6);
    }

    .text {
      position: absolute;
      width: 100%;
      color: $white;
      z-index: 10;
    }
  }

  /deep/ .image-modal .sweet-content-content {
    .candle-content {
      display: flex;
      align-items: center;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba($black, .6);
      }

      .text {
        position: absolute;
        color: $white;
        font-weight: bold;
        margin: auto;
        text-align: center;
        width: 100%;
        font-size: 40px;
      }

      img.img-fluid {
        width: 100%;
      }
    }
  }

  /deep/ .modal-form {
   overflow: auto;

    .sweet-modal {
      margin-bottom: 25px;
    }
  }

  @include editable-max-width(600px) {
    .image-modal .sweet-content-content .candle-content .text {
      font-size: 18px;
      padding: 10px;
      word-break: break-all;
    }

    /deep/ .modal-form {
      .sweet-modal {
        top: $nav-height;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Candle/index.vue